import {
    GET_CUSTOMER_TYPE_LIST_PROGRESS, GET_CUSTOMER_TYPE_LIST_SUCCESS, GET_CUSTOMER_TYPE_LIST_FAILURE,
    ADD_CUSTOMER_TYPE_PROGRESS, ADD_CUSTOMER_TYPE_SUCCESS, ADD_CUSTOMER_TYPE_FAILURE,
    EDIT_DELETE_CUSTOMER_TYPE_PROGRESS, EDIT_DELETE_CUSTOMER_TYPE_SUCCESS, EDIT_DELETE_CUSTOMER_TYPE_FAILURE,

    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    customerType: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const customer_type_reducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_CUSTOMER_TYPE_LIST_SUCCESS:
            return { ...state, customerType: action.customerType, loading: false };
        case GET_CUSTOMER_TYPE_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_CUSTOMER_TYPE_LIST_PROGRESS:
            return { ...state, loading: true, error: false };

        case ADD_CUSTOMER_TYPE_PROGRESS:
            return { ...state, loading: true };
        case ADD_CUSTOMER_TYPE_SUCCESS:
            return { ...state, customerType: [...state.customerType, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_CUSTOMER_TYPE_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case EDIT_DELETE_CUSTOMER_TYPE_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_CUSTOMER_TYPE_SUCCESS:
            return {
                ...state,
                customerType: state.customerType.map((customerType) =>
                    customerType.id === action.payload.id ? action.payload : customerType
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_CUSTOMER_TYPE_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case RESET_MESSAGE:
            return { ...state, message: null };

        default:
            return state
    }
}

export default customer_type_reducer;